import { render } from "./toggle-switch.html?vue&type=template&id=77796dc5&scoped=true&ts=true&external"
import script from "./toggle-switch.ts?vue&type=script&lang=ts&external"
export * from "./toggle-switch.ts?vue&type=script&lang=ts&external"

import "./toggle-switch.scss?vue&type=style&index=0&id=77796dc5&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77796dc5"]])

export default __exports__